export default __webpack_public_path__ + "static/media/ic_propbably.42f13f04.svg";